$(document).on('click', '.js_footer__links-title', function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active')
        $(this).next('.js_footer__links-list').slideUp(300)
    } else {
        $('.js_footer__links-title').removeClass('active')
        $('.js_footer__links-list').slideUp(300)
        $(this).addClass('active')
        $(this).next('.js_footer__links-list').slideDown(300)
    }
})

$(window).on('resize', function() {
    if ($(window).outerWidth() > 767) {
        $('.js_footer__links-title').removeClass('active')
        $('.js_footer__links-list').removeAttr('style')
    }
})